import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    sourceList: () => {
        return HTTP.get('/stock/setting/all-source', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addSource: (data) => {
        return HTTP.post('/stock/setting/create-source',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editSource: (id,data) => {
        return HTTP.post(`/stock/setting/update-source/${id}`,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    detailSource: (id) => {
        return HTTP.get(`/stock/setting/edit-source/${id}`, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}